import React from "react";
import "../css/Grid.css";


const types = ["INSTAGRAM", "TIKTOK"];

const labels = {
  INSTAGRAM: "Instagram",
  TIKTOK: "TikTok"
};

function TabGroup({ onTabChange, activeTab }) {
  return (
    <div className="profile-grid-tabs">
      {types.map((type) => (
        <button
          key={type}
          className={`tab ${activeTab === type ? "is-active" : ""}`}
          onClick={() => onTabChange(type)}
        >
          {labels[type]}
        </button>
      ))}
    </div>
  );
}

export default TabGroup;
